import React, { useCallback } from 'react';
import { Button, NavDropdown } from 'react-bootstrap';
import { BsCheckCircle, BsCheckLg, BsGearWideConnected, BsXLg } from 'react-icons/bs';
import { connect, ConnectedProps } from 'react-redux';
import { showPromiseConfirm } from '../alerts';
import { sanitizeProcessedVideo, toggleProcessingMarkEnabled } from '../features/app/appSlice';
import { RootState } from '../store';
import TextIcon from './textIcon';

interface ISettingsDropdownProps extends PropsFromRedux, React.AllHTMLAttributes<HTMLDivElement> {}
const SettingsDropdown = ({
	sanitizeProcessedVideo,
	toggleProcessingMarkEnabled,
	processedMarkEnabled,
}: ISettingsDropdownProps) => {
	const onDeleteAllMarkersClick = useCallback(async () => {
		if (!(await showPromiseConfirm('Всі відмітки про обробку повідомлень будуть видалені. Бажаєте продовжити?')))
			return;
		sanitizeProcessedVideo(0);
	}, [sanitizeProcessedVideo]);

	const onToggleProcessingMarkEnabledClick = useCallback(
		() => toggleProcessingMarkEnabled(),
		[toggleProcessingMarkEnabled]
	);

	return (
		<NavDropdown
			title={
				<TextIcon inline Icon={BsGearWideConnected} size="lg" className="mt-n1">
					<span className="d-sm-none d-lg-inline">Налаштування</span>
				</TextIcon>
			}
			id="settingsDropdown"
		>
			<NavDropdown.Header>
				<TextIcon Icon={BsCheckCircle} className="mt-n1">
					Маркування оброблених сюжетів
				</TextIcon>
			</NavDropdown.Header>
			<NavDropdown.Item as={Button} onClick={onToggleProcessingMarkEnabledClick}>
				{processedMarkEnabled ? (
					<TextIcon Icon={BsCheckLg} className="text-success" iconLast>
						Маркування активне
					</TextIcon>
				) : (
					<TextIcon Icon={BsXLg} className="text-danger" iconLast>
						Маркування не активне
					</TextIcon>
				)}
			</NavDropdown.Item>
			<NavDropdown.Item as={Button} onClick={onDeleteAllMarkersClick}>
				Видалити всі маркери про обробку
			</NavDropdown.Item>
			{/* <NavDropdown.Divider /> */}
		</NavDropdown>
	);
};

const mapState = (state: RootState) => ({
	processedMarkEnabled: state.app.isProcessedMarksEnabled,
});

const mapDispatch = { sanitizeProcessedVideo, toggleProcessingMarkEnabled };

const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(SettingsDropdown);
